import { IMemberFeeDetails } from './feeDetail';

export class IVisitor {
    _id             : string;
    name            : string;
    dateOfBirth     : Date;
    gender          : string;
    email           : string;
    phone           : string;
    date            : Date;
    company         : string;
    branch          : string;
    createdBy       : string;
    modifiedBy      : string;
    type            : string;
    scope           : string;
    initiatedFrom   : string;
    activityBy      : string;
    dayPass         : String;
    feeDetails      : IMemberFeeDetails[];
    SRBInvoiceID    : String;
    FBRInvoiceID?   : string;
    FBRInvoiceIDs?  : string[];
    branchName      : String;
}